module.exports = __webpack_public_path__ + "img/scl.4e876bbb.jpeg";